import React from "react";
import Pagination from "react-js-pagination";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

const QuyTienMatDetailTable = ({
  data,
  totalMoney,
  totalCommission,
  totalRecords,
  pageIndex,
  pageSize,
  onPageChange,
  loading,
  config,
  category,
  flow,
  onMoneyClick,
}) => {
  const showHoaHong =
    (config?.HoaHongTraGop === "1" || config?.hoaHongTraGop === "1") &&
    (category === "TRAGOP" || category === "BHTG");

  const showGhiChu = ["QUYKHAC", "RUTQUY", "TRICHLAP"].includes(category);

  const showMaPhieu = [
    "CAMDO",
    "TINCHAP",
    "TRAGOP",
    "QUYKHAC",
    "TRICHLAP",
    "RUTQUY",
  ].includes(category);

  const showLoaiGD = category !== "TRICHLAP";

  const clickableTypes = [
    "Đóng lãi",
    "Thanh toán",
    "Tất toán",
    "Thu phí khác",
    "Thanh toán hoa hồng",
    "Đóng lãi quá hạn",
  ];

  const getKhachHangHeader = (cat) => {
    if (cat === "HUYDONG") return "Chủ nợ";
    if (cat === "NGUONVON") return "Cổ đông";
    if (cat === "TRICHLAP") return "Chi nhánh";
    return "Khách hàng";
  };

  const getMaPhieuHeader = (cat) => {
    return cat === "TRICHLAP" ? "Mã phiếu" : "Mã HĐ";
  };

  const getTienHeader = (cat, fl) => {
    if (cat === "TRICHLAP")
      return fl === "THU" ? "Thu trích lập" : "Chi trích lập";
    return fl === "THU" ? "Tiền thu" : "Tiền chi";
  };

  if (loading) {
    return (
      <div className="card border-light mb-1 card-v2">
        <div className="card-body card-body-v2 text-center p-5">
          <div className="loader loader-default is-active"></div>
        </div>
      </div>
    );
  }

    return (
        <div className="Left808x200 Table-main-new css-table-ds">
            <div className="table-mobile table-mobile-hover">
                <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                    <div className="table-headers word-break" style={{ alignItems: 'stretch', backgroundColor: '#f8f9fc' }}>
                        <div className="custom-table-header text-center flex-basis-5 flex-basis-5-sm" style={{ justifyContent: 'center' }}>
                            <p className="color-do-bold">STT <br /> <span className="color-do-bold">[{totalRecords}]</span></p>
                        </div>
                        {showMaPhieu && (
                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'center' }}>
                                <p>{getMaPhieuHeader(category)}</p>
                            </div>
                        )}
                        {category === 'TRICHLAP' && (
                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'center'}}>
                                <p>Ngày</p>
                            </div>
                        )}

            <div
              className="custom-table-header flex-basis-12 flex-basis-12-sm"
              style={{ justifyContent: "flex-start", paddingLeft: "10px" }}
            >
              <p>Nhân viên</p>
            </div>

            <div
              className="custom-table-header flex-basis-15 flex-basis-15-sm"
              style={{ justifyContent: "flex-start", paddingLeft: "10px" }}
            >
              <p>{getKhachHangHeader(category)}</p>
            </div>
            {category !== "TRICHLAP" && (
              <div
                className="custom-table-header text-center flex-basis-10 flex-basis-10-sm"
                style={{ justifyContent: "center" }}
              >
                <p>Ngày giao dịch</p>
              </div>
            )}
            {showLoaiGD && (
              <div
                className="custom-table-header flex-basis-13 flex-basis-13-sm"
                style={{ justifyContent: "flex-start", paddingLeft: "10px" }}
              >
                <p>Loại giao dịch</p>
              </div>
            )}

            {showGhiChu && (
              <div
                className="custom-table-header flex-basis-15 flex-basis-15-sm"
                style={{ justifyContent: "flex-start", paddingLeft: "10px" }}
              >
                <p>Ghi chú</p>
              </div>
            )}

            {showHoaHong && (
              <div
                className="custom-table-header text-right flex-basis-10 flex-basis-10-sm"
                style={{ justifyContent: "flex-end", paddingRight: "10px" }}
              >
                <p>
                  Hoa hồng <br />
                  <span className="color-do-bold" style={{ fontSize: "12px" }}>
                    $={formatNumber(Math.abs(totalCommission))}
                  </span>
                </p>
              </div>
            )}

            <div
              className="custom-table-header text-right flex-basis-15 flex-basis-15-sm"
              style={{ justifyContent: "flex-end", paddingRight: "10px" }}
            >
              <p>
                {getTienHeader(category, flow)} <br />
                <span
                  className={flow === "THU" ? "color-do-bold" : "color-do-bold"}
                  style={{}}
                >
                  $= {flow === "CHI" ? "\u2212" : ""}
                  {formatNumber(Math.abs(totalMoney))}
                </span>
              </p>
            </div>
          </div>

                    <div className="custom-table-body">
                        {data.map((item, index) => (
                            <div 
                                key={index} 
                                className="custom-table-row" 
                                style={{ minHeight: "45px", borderBottom: '1px solid #e0e0e0' }}
                            >
                                <div className="custom-table-cell flex-basis-5 flex-basis-5-sm" style={{ justifyContent: 'center' }}>
                                    <span className="mobile-column-name color7-bold">STT</span>
                                    <div className="center-wrapper word-break text-center">{(pageIndex - 1) * pageSize + index + 1}</div>
                                </div>
                                {showMaPhieu && (
                                    <div className="custom-table-cell flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'center' }}>
                                        <span className="mobile-column-name color7-bold">{getMaPhieuHeader(category)}</span>
                                        <span className="center-wrapper word-break text-center">{item.MaHopDong}</span>
                                    </div>
                                )}
                                {category === 'TRICHLAP' && (
                                    <div className="custom-table-cell flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'center' }}>
                                        <span className="mobile-column-name color7-bold">Ngày</span>
                                        <div className="center-wrapper word-break text-center">{getDate(item.NgayGiaoDich)}</div>
                                    </div>
                                )}
                                <div className="custom-table-cell flex-basis-12 flex-basis-12-sm" style={{ justifyContent: 'flex-start', paddingLeft: '10px'}}>
                                    <span className="mobile-column-name color7-bold">Nhân viên</span>
                                    <div className="center-wrapper word-break">{item.NhanVien}</div>
                                </div>
                                <div className="custom-table-cell flex-basis-15 flex-basis-15-sm" style={{ justifyContent: 'flex-start', paddingLeft: '10px' }}>
                                    <span className="mobile-column-name color7-bold">{getKhachHangHeader(category)}</span>
                                    <div className="center-wrapper word-break">{item.KhachHang}</div>
                                </div>
                                {category !== 'TRICHLAP' && (
                                    <div className="custom-table-cell flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'center' }}>
                                        <span className="mobile-column-name color7-bold">Ngày giao dịch</span>
                                        <div className="center-wrapper word-break text-center">{getDate(item.NgayGiaoDich)}</div>
                                    </div>
                                )}
                                {showLoaiGD && (
                                    <div className="custom-table-cell flex-basis-13 flex-basis-13-sm" style={{ justifyContent: 'flex-start', paddingLeft: '10px' }}>
                                        <span className="mobile-column-name color7-bold">Loại giao dịch</span>
                                        <div className="center-wrapper word-break">{item.LoaiGiaoDich}</div>
                                    </div>
                                )}
                                {showGhiChu && (
                                    <div className="custom-table-cell flex-basis-15 flex-basis-15-sm" style={{ justifyContent: 'flex-start', paddingLeft: '10px' }}>
                                        <span className="mobile-column-name color7-bold">Ghi chú</span>
                                        <div className="center-wrapper word-break">{item.GhiChu}</div>
                                    </div>
                                )}
                                {showHoaHong && (
                                    <div className="custom-table-cell flex-basis-10 flex-basis-10-sm" style={{ justifyContent: 'flex-end', paddingRight: '10px'}}>
                                        <span className="mobile-column-name color7-bold">Hoa hồng</span>
                                        <div className="center-wrapper word-break text-right">{formatNumber(item.PhiHoaHong)}</div>
                                    </div>
                                )}
                                <div className="custom-table-cell flex-basis-15 flex-basis-15-sm" style={{ justifyContent: 'flex-end', paddingRight: '10px'}}>
                                    <span className="mobile-column-name color7-bold">{getTienHeader(category, flow)}</span>
                                    
                                    {clickableTypes.includes(item.LoaiGiaoDich) ? (
                                        <a 
                                            className={flow === 'THU' ? "color-xanh-bold center-wrapper word-break text-right btn-link" : "color-do-bold center-wrapper word-break text-right btn-link"} 
                                            style={{ fontWeight: 600, cursor: 'pointer'}}
                                            onClick={() => onMoneyClick(item.ThuChiID, item.LoaiGiaoDich)} 
                                        >
                                            {formatNumber(Math.abs(item.SoTien))}
                                        </a>
                                    ) : (
                                        <span className={flow === 'THU' ? "color-do-bold center-wrapper word-break text-right" : "color-do-bold center-wrapper word-break text-right"} style={{ fontWeight: 600 }}>
                                            {formatNumber(Math.abs(item.SoTien))}
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {totalRecords > pageSize && (
                <div className="row mt-2 mb-2">
                    <div className="col-sm-12 col-md-6 d-flex align-items-center">
                        <span className="color7">
                            Hiển thị {(pageIndex - 1) * pageSize + 1} - {Math.min(pageIndex * pageSize, totalRecords)} / {totalRecords}
                        </span>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="d-flex justify-content-end">
                            <Pagination
                                activePage={pageIndex}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={onPageChange}
                                itemClass="page-item border-none"
                                linkClass="page-link border-none"
                                activeClass="active"
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default QuyTienMatDetailTable;
